import ItemRules from './ItemRules';

const defaultItemIdentifier = 'warehouse';

export default function getItemRules(configurationData) {
  const itemIdentifier = configurationData.itemIdentifier || defaultItemIdentifier;
  let itemRulesFn = ItemRules[itemIdentifier];
  if (!itemRulesFn) {
    console.warn(`No rules defined for: ${itemIdentifier}`);
    itemRulesFn = ItemRules[defaultItemIdentifier];
  }
  return itemRulesFn(configurationData);
}
